module.exports = __webpack_public_path__ + "img/Nicolas Pepe.23953c03.png";